import { compile } from "ejs";
import type { GeoJsonProperties } from "geojson";
import template from "./templates/isigmet.ejs?raw";

const compiledTemplate = compile(template);

export function createSigmetTooltip(features: GeoJsonProperties) {
  return compiledTemplate({ features });
}
